module.exports = __webpack_public_path__ + "img/al-momento.93ff120b.png";